import { DateTime } from 'luxon';

export function createWhenString(departureTime: string | undefined, arrivalTime: string | undefined): string {
  if (!departureTime || !arrivalTime) {
    return '';
  }

  const from = DateTime.fromISO(departureTime);
  const to = DateTime.fromISO(arrivalTime);

  let result = '';
  if (from.hasSame(to, 'day')) {
    result = `${from.toFormat('EEEE dd MMMM yyyy  HH:mm')}-${to.toFormat('HH:mm')}`;
  } else {
    result = `${from.toFormat('EEEE dd MMMM yyyy  HH:mm')}  -  ${to.toFormat('EEEE dd MMMM yyyy  HH:mm')}`;
  }
  return `${result.substring(0, 1).toUpperCase()}${result.substring(1)}`;
}
